const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "DEPARTMENTS_TOGGLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, open: !state.filters.open },
      };
    case "DEPARTMENTS_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "DEPARTMENTS_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "DEPARTMENTS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "DEPARTMENTS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "DEPARTMENTS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
